import React from 'react';

export const TabNavigatorContext = React.createContext();

export const tabNavigatorContext = () => React.useContext(TabNavigatorContext);
